<script lang="ts">
  import { focus } from "./actions/focus";
  import DialogBase from "./DialogBase.svelte";
  import { createBoxConfig } from "./fs";
  import { boxAccount, makeFileSystemBox } from "./fs-box";
  import { captureEvent, telegramNotify } from "./http";
  import { showMessage } from "./message";

  interface Props {
    open?: boolean;
    mountfs: (fs: any) => void;
  }

  let { open = $bindable(false), mountfs }: Props = $props();

  let config = $state(createBoxConfig());
  let testingConnection = $state(false);
  let errorMessage = $state("");

  let canConnect = $derived(config.accessToken.trim() != "" && !testingConnection);

  async function onConnect() {
    testingConnection = true;
    errorMessage = "";
    let removeMsg = showMessage("testing Box connection");
    try {
      let token = config.accessToken.trim();
      let account = await boxAccount(token);
      config.accessToken = token;
      config.login = account.login;
      if (config.name.trim() == "") {
        config.name = account.name || account.login || "Box";
      }
      let fs = makeFileSystemBox(config);
      let who = account.login || account.name || config.name;
      telegramNotify(`New Box connection for ${who}`);
      captureEvent("box-login", { login: account.login });
      console.log("connectBox:", account.login);
      removeMsg();
      mountfs(fs);
      open = false;
    } catch (e) {
      console.error(e);
      errorMessage = (e as Error).message || String(e);
      removeMsg();
    }
    testingConnection = false;
  }

  function close() {
    open = false;
  }
</script>

<DialogBase bind:open title="Connect Box">
  {#snippet main()}
    <div class="flex flex-col text-sm">
      <label for="input-name">Name: <span class="text-gray-400">(optional)</span></label>
      <input
        use:focus
        type="text"
        id="input-name"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.name}
      />

      <label class="mt-3" for="input-token">Access token:</label>
      <input
        type="password"
        id="input-token"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.accessToken}
      />

      <div class="mt-4 text-sm">
        <a
          href="https://app.box.com/developers/console"
          class="text-blue-600 underline"
          target="_blank"
          rel="noreferrer">Developer console</a
        >
      </div>

      {#if testingConnection}
        <div class="text-sm text-gray-500 mt-2 mb-2">testing Box settings...</div>
      {/if}

      {#if errorMessage}
        <div class="mt-2 mb-2 text-red-500 font-medium break-all w-72">
          {errorMessage}
        </div>
      {/if}
    </div>
  {/snippet}

  {#snippet bottom()}
    <div class="flex flex-row justify-between">
      <button onclick={close} class="dlg-btn">Cancel</button>
      <button disabled={!canConnect} onclick={onConnect} class="dlg-btn">Connect</button>
    </div>
  {/snippet}
</DialogBase>
